import React from "react";
import getString from "../../../../config/strings";
import Subscriber from "../../../common/Subscriber";
import {
  FooterContainer,
  SubscriberSection,
  SubscribeTexts,
  SubscribeHeading,
  SubscribeText,
  MarketingContainer,
  TermsOfServiceOpener,
  PoweredBy,
  Socials,
  Email,
  Reddit,
  Twitter,
} from "./styles";
import EmailSVG from "../../../../resources/email.svg";
import RedditSVG from "../../../../resources/reddit.svg";
import TwitterSVG from "../../../../resources/twitter.svg";
import { isMobile } from "../../../../utils/common";
import ReactGA from "react-ga";
import TermsOfService from "./TermsOfService";

function Footer() {
  const [isTOSShown,setIsTOSShown] = React.useState(false);
  return (
    <FooterContainer>
      <SubscriberSection>
        <SubscribeTexts>
          <SubscribeHeading>
            {getString("Home_GetAccessToday")}
          </SubscribeHeading>
          <SubscribeText>{getString("Home_GetAccessSubText")}</SubscribeText>
        </SubscribeTexts>
        <Subscriber />
      </SubscriberSection>
      <MarketingContainer>
        <TermsOfServiceOpener
          onClick={() => {
            ReactGA.event({
              category: "Home",
              action: "Opened Terms of Service",
            });
            setIsTOSShown(true);
          }}
        >
          {getString("TermsOfService")}
        </TermsOfServiceOpener>
        {isTOSShown && <TermsOfService closeTOS={()=>{setIsTOSShown(false)}}/>}
        <PoweredBy>
          © 2021 Market Sentiment.{isMobile() ? <br /> : ""}{" "}
          {getString("Home_BuiltBy")} Market Sentiment Team
        </PoweredBy>
        <Socials>
          <Email
            src={EmailSVG}
            onClick={() => {
              ReactGA.event({
                category: "Home",
                action: "Social Click",
                label: "Email",
              });
              window.open("mailto:marketsentiment.live@gmail.com");
            }}
          />
          <Reddit
            src={RedditSVG}
            onClick={() => {
              ReactGA.event({
                category: "Home",
                action: "Social Click",
                label: "Reddit",
              });
              window.open("https://www.reddit.com/r/market_sentiment/");
            }}
          />
          <Twitter
            src={TwitterSVG}
            onClick={() => {
              ReactGA.event({
                category: "Home",
                action: "Social Click",
                label: "Twitter",
              });
              window.open("https://mobile.twitter.com/mkt_sentiment");
            }}
          />
        </Socials>
      </MarketingContainer>
    </FooterContainer>
  );
}
export default Footer;
